import { Constants } from "../../../../../../../common/constants";
import { RouterInferenceHelpers } from "../../../../../../../src/api/trpc/rootRouter";
import { GenericEntitlement } from "./generic_entitlement";

export function PatreonEntitlement(
	props: Pick<
		RouterInferenceHelpers["premium"]["getUserPremiumDetails"]["output"],
		"patreon_activations" | "is_patreon_purely_from_override"
	>
) {
	const title =
		props.patreon_activations > 3 ? "Sesh Premium Plus" : "Sesh Premium";

	return (
		<GenericEntitlement
			type="Patreon"
			title={title}
			modify_link={
				<a
					href={Constants.PATREON_LINK}
					target="_blank"
					className="secondary-link"
				>
					Modify
				</a>
			}
			details={
				<>
					<div>
						Activations Granted:{" "}
						<span className="font-bold">
							{props.patreon_activations}
						</span>
					</div>
					<div>
						Status: <span className="font-bold">active</span>
					</div>
				</>
			}
		/>
	);
}
